<div [innerHTML]="cellInnerHTML" class="url-grid-cell"></div>
